<template>
  <v-dialog
    :x-fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    max-width="300"
    :x-max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    x-content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card">
      <v-system-bar height="16" color="primary"></v-system-bar>
      <v-card-text>
        <v-form v-model="valid" ref="form">
          <v-container>
            <v-list-item>
              <v-text-field
                v-model="tableName"
                :rules="[inputRules.required]"
                :label="$t('ask_table_name')"
                required
              ></v-text-field>
            </v-list-item>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primaryText" class="primary--text" @click.native="close(null)">{{ $t("cancel") }}</v-btn>
        <v-btn class="confirm-button" :disabled="!valid" @click.native="confirm">{{
          $t("confirm")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,

    valid: false,
    tableName: "",
  }),

  methods: {
    open() {
      if (this.$store.state.order.tableID != null && this.$store.state.order.tableID > 0) {
        this.tableName = this.$store.state.order.tableName;
      }

      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close(result) {
      this.$refs.form.reset();
      this.dialog = false;
      this.resolve(result);
    },

    confirm() {
      this.close(this.tableName);
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-button {
  background-color: var(--v-primary-base) !important;
  color: var(--v-primaryText-base) !important;
}

.theme--light.v-btn.v-btn--disabled.confirm-button {
  background-color: var(--v-primary-base) !important;
  color: var(--v-primaryText-base) !important;
}
</style>
